import { AxiosResponse } from 'axios'
import { giveProductToCustomer as giveProductToCustomerAPI, UpdatedTaskStatus } from '../../api/smartbestbuys-api'

export const confirmToGiveProduct = async (id: number): Promise<AxiosResponse<UpdatedTaskStatus> | null> =>
  giveProductToCustomerAPI(id)
